 

//   import { Link, useNavigate, useSearchParams } from "react-router-dom";
// import { useEffect, useState } from "react";
// import "../App.css";
// import ThreeDotMenu from "./ThreeDotMenu";

// const placeholderWords = ["jacket", "drill bit", "lehenga", "calculator"];

// function Navbar() {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   const [text, setText] = useState(searchParams.get("search") || "");
//   const [placeholder, setPlaceholder] = useState("");
//   const [wordIndex, setWordIndex] = useState(0);
//   const [charIndex, setCharIndex] = useState(0);
//   const user = JSON.parse(localStorage.getItem("user"));
//   // Navbar.jsx ke return se pehle:
  
//   const ADMIN_MOBILE = "9024513184";

//   /* 🔤 placeholder typing effect (exact old style) */
//   useEffect(() => {
//     const currentWord = placeholderWords[wordIndex];

//     const typingInterval = setInterval(() => {
//       setPlaceholder(currentWord.slice(0, charIndex + 1));
//       setCharIndex((prev) => prev + 1);
//     }, 120);

//     if (charIndex === currentWord.length) {
//       clearInterval(typingInterval);
//       setTimeout(() => {
//         setCharIndex(0);
//         setWordIndex((prev) => (prev + 1) % placeholderWords.length);
//         setPlaceholder("");
//       }, 1000);
//     }

//     return () => clearInterval(typingInterval);
//   }, [charIndex, wordIndex]);

//   /* 🔁 URL → input sync */
//   useEffect(() => {
//     const currentSearch = searchParams.get("search") || "";
//     if (currentSearch !== text) {
//       setText(currentSearch);
//     }
//   }, [searchParams]);

//   const handleSearch = (e) => {
//     const value = e.target.value;
//     setText(value);
//     navigate(`/home?search=${value}`);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     navigate("/login");
//     window.location.reload();
//   };

//   return (
//     <nav className="navbar navbar-expand-lg bg-white border-bottom px-4">
        
//         <ThreeDotMenu />
        
//       {/* LOGO */}
//       <Link className="navbar-brand fw-bold fs-4 me-4" to="/home">
//         <span className="text-primary">Borrow</span>
//         <span className="text-success">Hub</span>
//       </Link>

//       {/* SEARCH */}
//       <div className="flex-grow-1 mx-4">
//         <input
//           type="text"
//           className="form-control form-control-lg"
//           placeholder={`Search for ${placeholder}`}
//           value={text}
//           onChange={handleSearch}
//         />
//       </div>

//       {/* RIGHT BUTTONS */}
//       <div className="d-flex gap-2">
//         <Link to="/add-item" className="btn btn-success">
//           + Add Item
//         </Link>

//         {/* Navbar ke andar jahan baaki links hain */}
// <Link to="/handover" className="btn btn-warning fw-bold ms-2">
//   📦 Pending Handovers
// </Link>

//         <Link to="/my-items" className="btn btn-outline-success">
//           My Items
//         </Link>

//         <button
//           className="btn btn-outline-secondary"
//           onClick={() => navigate("/chats")}
//         >
//           💬 Chats
//         </button>


//         {/* 🔥 CORRECTED ADMIN BUTTON CHECK */}
//         {/* Yahan 'user.phone' use kiya hai kyunki database me 'phone' hai */}
//         {user && String(user.phone) === ADMIN_MOBILE && (
//              <Link 
//                to="/admin" 
//                className="btn btn-danger fw-bold border border-danger ms-2"
//              >
//                👮
//              </Link>
//         )}

//           <Link to="/profile" className="nav-link d-flex align-items-center gap-2">
//   <img 
//     src={user?.profilePic || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} 
//     alt="Profile"
//     className="rounded-circle border border-2 border-primary"
//     style={{ 
//       width: "40px", 
//       height: "40px", 
//       objectFit: "cover" // Isse photo pichkegi nahi, proper gol dikhegi
//     }} 
//   />
  
//   {/* Agar naam bhi dikhana hai to ye line rakho, varna hata do */}
//   <span className="fw-bold small text-dark d-none d-md-block">
//     {user?.name?.split(" ")[0] }
//   </span>
// </Link>
//       </div>
//     </nav>
//   );
// }

// export default Navbar;



import { Link, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import "../App.css";
import ThreeDotMenu from "./ThreeDotMenu";

const placeholderWords = ["jacket", "drill bit", "lehenga", "calculator"];

function Navbar() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation(); // To refresh counts on page change

  const [text, setText] = useState(searchParams.get("search") || "");
  const [placeholder, setPlaceholder] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  
  // 🔥 BADGE COUNTS STATE
  const [counts, setCounts] = useState({ handovers: 0, myItems: 0 });

  const user = JSON.parse(localStorage.getItem("user"));
  const ADMIN_MOBILE = "9024513184";

  /* 🔤 Placeholder Effect (Same as yours) */
  useEffect(() => {
    const currentWord = placeholderWords[wordIndex];
    const typingInterval = setInterval(() => {
      setPlaceholder(currentWord.slice(0, charIndex + 1));
      setCharIndex((prev) => prev + 1);
    }, 120);

    if (charIndex === currentWord.length) {
      clearInterval(typingInterval);
      setTimeout(() => {
        setCharIndex(0);
        setWordIndex((prev) => (prev + 1) % placeholderWords.length);
        setPlaceholder("");
      }, 1000);
    }
    return () => clearInterval(typingInterval);
  }, [charIndex, wordIndex]);

  /* 🔁 Sync Search & 🔥 FETCH BADGE COUNTS */
  useEffect(() => {
    const currentSearch = searchParams.get("search") || "";
    if (currentSearch !== text) setText(currentSearch);

    // 🔥 Fetch Notification Dots
    const fetchCounts = async () => {
        if (!user) return;
        try {
            const token = localStorage.getItem("token");
            const res = await fetch("https://borrowhub-backend.onrender.com/api/borrows/navbar-counts", {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) {
                setCounts({ 
                    handovers: data.pendingHandovers, 
                    myItems: data.activeBorrows 
                });
            }
        } catch (err) { console.error(err); }
    };
    fetchCounts();

  }, [searchParams, location.pathname]); // Page badalne par counts refresh honge

  const handleSearch = (e) => {
    const value = e.target.value;
    setText(value);
    navigate(`/home?search=${value}`);
  };

  return (
    <nav className="navbar navbar-expand-lg bg-white border-bottom px-4">
        <ThreeDotMenu />
      
      
       {/* LOGO SECTION */}
<Link className="navbar-brand d-flex align-items-center me-2" to="/home">
  {/* Desktop: Yahan poora naam dikhega */}
  <span className="d-none d-md-inline fw-bold fs-4">
     <span className="text-primary">Borrow</span><span className="text-success">Hub</span>
  </span>
  
  {/* Mobile/APK: Yahan tera gol chota logo dikhega */}
  <img 
    src="/logo.png" 
    alt="logo" 
    className="d-inline d-md-none rounded-circle border border-2 border-success" 
    style={{ 
      width: "38px", 
      height: "38px", 
      objectFit: "cover" 
    }} 
  />
</Link>

      {/* SEARCH */}
      <div className="flex-grow-1 mx-4">
        <input
          type="text"
          className="form-control form-control-lg"
          placeholder={`Search for ${placeholder}`}
          value={text}
          onChange={handleSearch}
        />
      </div>

      {/* RIGHT BUTTONS */}
      <div className="d-flex gap-2 align-items-center">
        <Link to="/add-item" className="btn btn-success">+ Add Item</Link>

        {/* 📦 PENDING HANDOVERS (LENDER SIDE) */}
        <Link to="/handover" className="btn btn-warning fw-bold ms-2 position-relative">
          📦 Handover
          {/* 🔴 RED DOT if pending handovers > 0 */}
          {counts.handovers > 0 && (
            <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
               <span className="visually-hidden">Alert</span>
            </span>
          )}
        </Link>

        {/* 👜 MY ITEMS (BORROWER SIDE) */}
        <Link to="/my-items" className="btn btn-outline-success position-relative">
          My Items
          {/* 🟢 GREEN DOT if active borrows > 0 */}
          {counts.myItems > 0 && (
            <span className="position-absolute top-0 start-100 translate-middle p-2 bg-success border border-light rounded-circle">
               <span className="visually-hidden">Active</span>
            </span>
          )}
        </Link>

        <button className="btn btn-outline-secondary" onClick={() => navigate("/chats")}>
          💬
        </button>
        {/* 💰 MY EARNINGS BUTTON */}
<Link to="/earnings" className="btn btn-outline-success" title="My Earnings">
  💰
</Link>

        {/* ADMIN */}
        {user && String(user.phone) === ADMIN_MOBILE && (
             <Link to="/admin" className="btn btn-danger fw-bold border border-danger ms-2">👮</Link>
        )}

        {/* PROFILE */}
        <Link to="/profile" className="nav-link d-flex align-items-center gap-2">
          <img 
            src={user?.profilePic || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"} 
            alt="Profile"
            className="rounded-circle border border-2 border-primary"
            style={{ width: "40px", height: "40px", objectFit: "cover" }} 
          />
          <span className="fw-bold small text-dark d-none d-md-block">
            {user?.name?.split(" ")[0] }
          </span>
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;